module.exports = __webpack_public_path__ + "img/new-people-chef-holding-bags.771d7d31.png";